<template>
  <div class="sidebar-menu">
    <emb-perfect-scrollbar class="scroll-area" :settings="settings">
      <v-list>
        <div class="close-btn-sidebar layout justify-end mx-4 pt-2">
          <a href="javascript:void(0)" @click="toggleMobileSidebar">
            <i class="material-icons close-icon black--text">close</i>
          </a>
        </div>
        <template v-for="menu in menus">
          <template
            v-if="menu.Children_List !== null && menu.Children_List.length > 0"
          >
            <v-list-group
              light
              :key="menu.Title"
              no-action
              v-model="menu.active"
            >
              <v-list-item class="px-0" slot="activator">
                <!-- <v-list-item class="px-0" slot="activator" :to="menu.Path"> -->
                <!-- <v-list-item-action class="mr-0">
                  <v-icon>{{menu.Title.toLowerCase()}}</v-icon>
                </v-list-item-action>-->
                <v-list-item-title>{{ menu.Title }}</v-list-item-title>
              </v-list-item>

              <template v-if="menu.Type === 'sub_menu'">
                <template v-for="subItem in menu.Children_List">
                  <v-list-item
                    class="sub-menu-item"
                    :key="subItem.Title"
                    v-if="subItem !== null"
                    :to="subItem.Path"
                    @click="toggleMobileSidebar"
                  >
                    <template v-if="subItem.Children_List == null">
                      <v-list-item-action class="mr-0">
                        <v-icon>arrow_right_alt</v-icon>
                      </v-list-item-action>
                      <v-list-item-title class="sub-item">{{
                        subItem.Title
                      }}</v-list-item-title>
                    </template>

                    <template v-else>
                      <v-list-group
                        class="submenu-child"
                        no-action
                        sub-group
                        value="true"
                        prepend-icon="mdi mdi-chevron-down"
                      >
                        <template v-slot:activator>
                          <v-list-item-title>
                            <v-icon class="pr-2">arrow_right_alt</v-icon>
                            {{ subItem.Title }}
                          </v-list-item-title>
                        </template>

                        <v-list-item
                          v-for="(item, i) in subItem.Children_List"
                          :key="i"
                          link
                          :to="item.Path"
                          @click="toggleMobileSidebar"
                        >
                          <v-list-item-title class="sub-item">
                            <v-icon class="pr-2">arrow_right_alt</v-icon>
                            {{ item.Title }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list-group>
                    </template>
                  </v-list-item>
                </template>
              </template>
              <template v-if="menu.Type === 'mega_menu'">
                <template v-for="(subItem, subItemKey) in menu.Children_List">
                  <v-list-group
                    class="submenukey"
                    :key="subItemKey"
                    v-if="subItem !== null"
                    no-action
                    sub-group
                    prepend-icon="mdi mdi-chevron-down"
                    v-model="subItem.Is_Active"
                  >
                    <v-list-item slot="activator">
                      <a
                        :href="
                          subItem.Path + '/?category=' + subItem.Category_ID
                        "
                        @click="toggleMobileSidebar"
                      >
                        <v-list-item-title class="megamenu-key pl-1">
                          {{ subItem.Title }}
                        </v-list-item-title>
                      </a>
                    </v-list-item>
                    <v-list-item
                      v-for="(childMega, megaChildKey) in subItem.Children_List"
                      :key="megaChildKey + 'item'"
                      :to="
                        subItem.Path +
                        '?category=' +
                        subItem.Category_ID +
                        '&subcategory=' +
                        childMega.Category_ID
                      "
                      class="mega-menu-item"
                    >
                      <v-list-item-action class="mr-0 pl-1">
                        <v-icon>arrow_right_alt</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        childMega.Title
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list-group>
                </template>
              </template>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-item :key="menu.Title" :to="menu.Path">
              <v-list-item-content>
                <v-list-item-title>{{ menu.Title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
        <v-flex>
          <div class="langmenu">
            <emb-lang
              :topbarArea="topbarSection"
              class="language-sidebar"
            ></emb-lang>
            <emb-currency
              :topbarArea="topbarSection"
              class="language-sidebar"
            ></emb-currency>
          </div>
          <!-- <div>
              <v-col sm="4">
                <ColorPicker v-model="color.primary" :change="colorChange()" />
              </v-col>
              <v-col  sm="4">
                <ColorPicker v-model="color.accent" :change="colorChange()" />
              </v-col>
          </div> -->
        </v-flex>
      </v-list>
    </emb-perfect-scrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
import Lang from "../Header/Lang";
import Currency from "../Header/Currency";
// import ColorPicker from "primevue/colorpicker";
export default {
  components: {
    embPerfectScrollbar: VuePerfectScrollbar,
    embLang: Lang,
    embCurrency: Currency,
    // ColorPicker
  },
  data() {
    return {
      // subGroup: {
      //   "message.men": false,
      //   "message.women": false,
      //   "message.gadgets": false,
      //   "message.accessories": false,
      // },
      settings: {
        maxScrollbarLength: 360,
      },
      cmsRequestFunctions: null,
      topbarSection: {},
      color: { primary: "283593", accent: "ff5722" },
    };
  },
  computed: {
    ...mapGetters(["menus"]),
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  methods: {
    toggleMobileSidebar() {
      this.$store.dispatch("toggleSidebar", false);
    },
    scrollHanle(evt) {
      console.log(evt);
    },
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "01 Top Bar/01 Top Bar/01 Top Bar.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var topbarArea = self.cmsRequestFunctions.pluck(
              "Top_Bar_Section",
              res.area_List
            );
            self.topbarSection = self.cmsRequestFunctions.getAllMapData(
              topbarArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    colorChange() {
      this.$vuetify.theme.currentTheme.primary = "#" + this.color.primary;
      this.$vuetify.theme.currentTheme.accent = "#" + this.color.accent;
    },
  },
};
</script>